import React, { useMemo, useState } from 'react';
import { Box, MenuItem } from '@mui/material';
import { CustomButton, CustomSelect } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';

const MonthlyTurnover = ({
  industryType = '',
  questionId,
  title = "What's your monthly turnover?",
  titleHelperText = '(1 or more)',
  subtitle = 'This helps us give you more Social Security Benefits',
  options,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  type, // 'select' or 'button'
}) => {
  const resolvedQuestionId =
    questionId || 'business_bcm_turnover_all';
  const resolvedOptions = useMemo(
    () => options || [],
    [options],
  );
  const turnoverImage =
    industryType === 'Fmcg' ? PROFILER_IMAGES.turnoverFmcg : PROFILER_IMAGES.turnoverBcm;
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleSelect = (nextValue) => {
    if (!isControlled) {
      setInternalValue(nextValue);
    }
    onChange?.(nextValue);
  };


  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: resolvedQuestionId, value: selectedValue }
      ]
    });
  };

  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
        <CardHeader
          title={title}
          titleHelperText={titleHelperText}
          subtitle={subtitle}
        />
        <Box 
          component='img'
          alt='Brand Icon'
          width={75}
          sx={{ alignSelf: 'center'}}
          src={turnoverImage}
        />

        {type === 'select' ? (
          <CustomSelect
            value={selectedValue}
            onChange={e => handleSelect(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          >
            {resolvedOptions.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </CustomSelect>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {resolvedOptions.map((option) => {
              const isSelected = selectedValue === option.value;
              return (
                <CustomButton
                  key={option.value}
                  label={option.label}
                  variant={isSelected ? 'filled' : 'outlined'}
                  onClick={() => handleSelect(option.value)}
                  sx={{ width: '100%' }}
                  size='small'
                />
              );
            })}
          </Box>
        )}

        <CustomButton
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selectedValue}
          size='small'
          sx={{ width: '100%', mt: 'auto', pt: 1 }}
        />
      </Box>
    </Box>
  );
};

export default MonthlyTurnover;
